<template>
  <div>
    <label v-if="!templateEditing" class="vform-editor-label section">Text</label>
    <original-language-viewer
        v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
        :original-text="element.label.dix['Unknown']"
        class="mb-2"
    />
    <div class="vform-label lighter white">{{ $store.getters.getSelectedFormLanguage }}</div>
    <div
        v-for="(key, index2) in Object.keys(element.label.dix)"
        v-if="!templateEditing && $store.getters.getSelectedFormLanguage === key"
        :key="index2 + 1000000000 + forceReRenderKey"
        class="dflex"
    >
      <div class="col p-0">
        <vue-editor
            ref="editor"
            v-model="element.label.dix[key]"
            :editor-toolbar="toolbar"
        />

        <!--leaving it here in case we need source code view-->
        <textarea
            v-if="$store.getters.isSuperAdmin && false"
            v-model="element.label.dix[key]"
            :placeholder="
                        key === 'Unknown'
                            ? placeholders.LONG
                            : $t('vform.translationMessage', {
                                  key: key,
                                  content: element.label.dix['Unknown'],
                              })
                    "
            :title="element.label.dix['Unknown']"
            class="mb-1 form-text v-form-label form-text-dark"
            rows="300"
            type="text"
        />
      </div>
    </div>
    <div class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">Size</label>
      </div>
      <set-by-template v-if="selectedTemplate.textSize"/>
      <div
          v-for="(textCategory, index) in textCategories"
          v-else
          :key="index"
          :class="[
                    'vform-heading-cat-button clickable',
                    textCategory === element.textSize ? 'active' : '',
                ]"
          @click="setCategory(textCategory)"
      >
        <div :class="['size', textCategory]">Aa</div>
      </div>
    </div>
    <alignment-editor
        :element="element"
        :selected-template="selectedTemplate"
    />
    <div class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{
            $t("vform.noMarginBottom")
          }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label
            :for="'removeMarginBottom' + $vnode.key"
            class="container"
            style="padding-left: 5px !important"
        >
          <input
              :id="'removeMarginBottom' + $vnode.key"
              v-model="element.noMarginBottom"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <div class="col pl-0 pr-0 dflex" v-if="state && state.isTopBottomBarPanel">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{
            $t("showInline")
          }}</label>
      </div>
      <!--todo: add template thingy??-->
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label
            :for="'showInline' + $vnode.key"
            class="container"
            style="padding-left: 5px !important"
        >
          <input
              :id="'showInline' + $vnode.key"
              v-model="element.isInline"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <template v-if="!element.emphasized">
      <label class="vform-editor-label section">Background Color</label>
      <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
      <color-picker-and-field
          v-else
          :field-background-color="element.backgroundColor"
          @saveColor="(color) => {setItemColor('backgroundColor', color)}"
          @unsetColor="setItemColor('backgroundColor', null)"
      />

      <label class="vform-editor-label section">Font Color</label>
      <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
      <color-picker-and-field
          v-else
          :field-background-color="element.fontColor"
          @saveColor="(color) => {setItemColor('fontColor', color)}"
          @unsetColor="setItemColor('fontColor', null)"
      />


      <div
          v-if="(!selectedTemplate.backgroundColor && !selectedTemplate.fontColor) && (element.backgroundColor || element.fontColor)"
          class="settings-button d-inline-block mt-2"
          @click="element.backgroundColor = null; element.fontColor = null;">
        {{ $t('resetColor') }}
      </div>
      <br/>
    </template>

    <label v-if="!templateEditing" class="vform-editor-label section">Options</label>
    <div v-if="!templateEditing" class="col row dflex">
      <div class="dflex">
        <label
            :for="'chkEmphasized' + $vnode.key"
            class="container vform-editor-body"
        >{{ $t("emphasized") }}
          <input
              :id="'chkEmphasized' + $vnode.key"
              v-model="element.emphasized"
              type="checkbox"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js.vue";
import {vFormControls, placeholders} from "@/enum";
import SetByTemplate from "../vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import {VueEditor} from "vue2-editor";
import {sanitizeHtmlString} from "../vForm/viewer/textUtils";
import listenerMixinJs from "@/components/mixins/listenerMixin.js.vue";
import OriginalLanguageViewer from "@/components/vForm/OriginalLanguageViewer.vue";
import AlignmentEditor from "@/components/vForm/AlignmentEditor.vue";

export default {
  name: "vFormTEXT",
  components: {
    AlignmentEditor,
    ColorPickerAndField,
    SetByTemplate,
    VueEditor,
    OriginalLanguageViewer
  },
  mixins: [vFormElementMixin, listenerMixinJs],
  props: {
    element: {type: Object, required: true},
    stepNo: {type: Number, required: true},
    organizationId: {type: String, default: ""},
  },
  data() {
    return {
      forceReRenderKey: 0,
      colorPickrId: null,
      vFormControls: vFormControls,
      placeholders: placeholders,
      textCategories: ['small', 'medium', 'large'],
      alignments: ["left", "center", "right", "justify"],
      toolbar: [
        ["bold", "italic"],
        [{list: "ordered"}, {list: "bullet"}],
      ],
    };
  },
  beforeMount() {
    this.element.formElementType = vFormControls["TEXT"];
    if (!this.element.textSize) {
      this.setCategory('medium');
    }

    if (!this.element.textAlignment) {
      this.setTextAlignment('left');
    }
    if (this.element.noMarginBottom === undefined) {
      this.$set(this.element, "marginBottom", false);
    }
    if(this.element.isInline === undefined) {
      this.$set(this.element, "isInline", false);
    }
  },
  mounted() {
    const $this = this;
    this.$nextTick(() => {
      const vueComp = this.$refs.editor;
      const quill = vueComp[0].quill;
      if (!quill) return;
      $this.addListener(quill.root, 'paste', (e) => {
        this.handlePaste(e, quill)
      }, 'quill-paste');
    })
  },
  methods: {
    handlePaste(e, quill) {
      let dt = e.clipboardData || window.clipboardData;
      if (!dt) return; // let Quill handle default

      let html = dt.getData('text/html');
      let text = dt.getData('text/plain');
      if (!html && !text) return;

      e.preventDefault();

      let range = quill.getSelection(true) || {index: quill.getLength(), length: 0};

      // Replace selection manually so we can compute caret position reliably
      let beforeLen = quill.getLength();
      if (range.length) quill.deleteText(range.index, range.length, 'user');

      if (html && String(html).trim()) {
        let clean = sanitizeHtmlString(html);
        quill.clipboard.dangerouslyPasteHTML(range.index, clean, 'user');
      } else {
        quill.insertText(range.index, text, 'user');
      }

      // After insert, compute how much content got added
      let afterLen = quill.getLength();
      let insertedLen = afterLen - beforeLen + range.length;
      if (insertedLen < 0) insertedLen = 0; // paranoia

      quill.setSelection(range.index + insertedLen, 0, 'silent');
    },
    setCategory(val) {
      console.log('setting category', val);
      this.$set(this.element, "textSize", val);
      this.forceReRenderKey++;
    },
    setTextAlignment(val) {
      this.$set(this.element, "textAlignment", val);
      this.forceReRenderKey++;
    },
  }
};
</script>

<style lang="scss">
.quillWrapper {
  .ql-toolbar {
    border: 1px solid var(--vform-editor-ui-secondary-color);
    background: rgba(255, 255, 255, 0.8);
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    padding-top: 6px !important;
    padding-bottom: 0 !important;
  }

  .ql-container {
    border: 1px solid var(--vform-editor-ui-secondary-color) !important;
  }

  .ql-editor {
    background-color: var(--vform-editor-ui-quaternary-color);
  }
}
</style>

<style lang="scss" scoped>
.vform-heading-cat-button {
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 1px;
  margin-left: 1px;
  width: 25px;
  height: 25px;
  position: relative;
  color: #fff;
  transition: all 300ms ease;


  .size {
    vertical-align: baseline;
    font-size: 0.7rem;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin-top: 1px;
  }

  .small {
    font-size: 0.6rem;
  }

  .medium {
    font-size: 0.8rem;
  }

  .large {
    font-size: 1rem;
  }

  &.active, &:hover {
    background-color: var(--vform-editor-accent-color);
  }
}
</style>
